export default __webpack_public_path__ + "static/media/Screenshot_13.bd255829.png";